import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminService } from '../../api';
import './AdminUsersPage.css';

const AdminUsersPage = () => {
    const [items, setItems] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [busyId, setBusyId] = useState(null);

    const load = useCallback(() => {
        setLoading(true);
        setError(null);
        adminService.getUsers({ page, pageSize: 20, search: search || undefined })
            .then(({ data }) => {
                setItems(data.items);
                setTotalPages(data.totalPages);
            })
            .catch(() => setError('Не удалось загрузить пользователей.'))
            .finally(() => setLoading(false));
    }, [page, search]);

    useEffect(() => { load(); }, [load]);

    const submitSearch = (e) => {
        e.preventDefault();
        setPage(1);
        setSearch(searchInput.trim());
    };

    const toggleBan = async (u) => {
        setBusyId(u.id);
        try {
            if (u.isBanned) await adminService.unbanUser(u.id);
            else await adminService.banUser(u.id);
            setItems(prev => prev.map(x => x.id === u.id ? { ...x, isBanned: !x.isBanned } : x));
        } catch (e) {
            alert(e.response?.data ?? 'Не удалось изменить статус блокировки.');
        } finally {
            setBusyId(null);
        }
    };

    return (
        <div className="admin-users">
            <h1 className="admin-users__title">Пользователи</h1>

            <form className="admin-users__search" onSubmit={submitSearch}>
                <input
                    className="admin-users__search-input"
                    placeholder="Поиск по имени, email..."
                    value={searchInput}
                    onChange={e => setSearchInput(e.target.value)}
                />
                <button type="submit" className="admin-users__search-btn">Найти</button>
            </form>

            {loading && <div className="admin-users__placeholder">Загрузка...</div>}
            {error && <div className="admin-users__placeholder">{error}</div>}
            {!loading && !error && items.length === 0 && (
                <div className="admin-users__placeholder">Пользователи не найдены.</div>
            )}

            {!loading && !error && items.length > 0 && (
                <div className="admin-users__table-wrap">
                    <table className="admin-users__table">
                        <thead>
                            <tr>
                                <th>Имя</th>
                                <th>Email</th>
                                <th>Тип</th>
                                <th>Регистрация</th>
                                <th>Статус</th>
                                <th>Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(u => (
                                <tr key={u.id}>
                                    <td>
                                        <Link to={`/admin/users/${u.id}`} className="admin-users__link">
                                            {u.contactName || u.userName || u.id}
                                        </Link>
                                    </td>
                                    <td>{u.email}</td>
                                    <td>{u.accountType === 'company' ? 'Компания' : 'Частное лицо'}</td>
                                    <td>{new Date(u.registeredAt).toLocaleDateString('ru-RU')}</td>
                                    <td>
                                        {u.isBanned
                                            ? <span className="admin-users__badge admin-users__badge--banned">Заблокирован</span>
                                            : <span className="admin-users__badge admin-users__badge--active">Активен</span>}
                                    </td>
                                    <td>
                                        <button
                                            className={`admin-users__btn ${u.isBanned ? '' : 'admin-users__btn--danger'}`}
                                            disabled={busyId === u.id}
                                            onClick={() => toggleBan(u)}
                                        >
                                            {u.isBanned ? 'Разблокировать' : 'Заблокировать'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {totalPages > 1 && (
                <div className="admin-users__pagination">
                    <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Назад</button>
                    <span>{page} / {totalPages}</span>
                    <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Далее</button>
                </div>
            )}
        </div>
    );
};

export default AdminUsersPage;
